import {Event, EventConfig} from './index';
export enum EventAPIReturnOptions {
	MIN = "MIN",
	HALF = "HALF",
	FULL = "FULL",
}
export interface EventAPIConfig {
	data: Event|EventConfig;
	config: {
		return: EventAPIReturnOptions;
	}
}